import { forwardRef } from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/system';

const colorDisable = 'rgba(0, 0, 0, 0.26)';

type BtnOutlineGradientProps = {
  handleButtonClick: () => void;
  text: string;
  srcStartIcon?: string;
  srcEndIcon?: string;
  sx?: SxProps<Theme>;
  sxIcon?: SxProps<Theme>;
  sxButton?: SxProps<Theme>;
  sxText?: SxProps<Theme>;
  width?: string;
  id?: string;
  grandient?: string;
  color?: string;
  disabled?: boolean;
};

const BtnOutlineGradient = forwardRef<
  HTMLButtonElement,
  BtnOutlineGradientProps
>((props, ref) => {
  return (
    <Stack
      justifyContent={'center'}
      sx={{
        width: props.width ? props.width : '80px',
        height: '32px',
        p: '2px',
        borderRadius: '4px',
        background: props?.disabled ? colorDisable : props.grandient
          ? props.grandient
          : 'linear-gradient(95.64deg, #00C3FF 0%, #0090F8 100%)',
        ...props.sx,
      }}
    >
      <Button
        ref={ref}
        id={props.id}
        onClick={props.handleButtonClick}
        disabled={props.disabled}
        sx={{
          p: '0',
          width: '100%',
          height: '100%',
          backgroundColor: 'primary.light',
          borderRadius: '2px',
          '&:hover': { opacity: 0.8, backgroundColor: 'primary.light' },
          ...props.sxButton,
        }}
      >
        {props.srcStartIcon && (
          <Box
            component='img'
            src={props.srcStartIcon}
            alt='icon'
            mr='4px'
            sx={props.sxIcon}
          />
        )}

        <Typography
          fontSize='12px'
          fontWeight='700'
          lineHeight={'28px'}
          height={'100%'}
          borderRadius={'2px'}
          sx={{
            background: props?.disabled ? colorDisable : props.color
              ? props.color
              : 'linear-gradient(95.64deg, #00C3FF 0%, #0090F8 100%)',
            backgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            ...props.sxText,
          }}
        >
          {props.text}
        </Typography>

        {props.srcEndIcon && (
          <Box
            component='img'
            src={props.srcEndIcon}
            alt='icon'
            ml='4px'
            sx={props.sxIcon}
          />
        )}
      </Button>
    </Stack>
  );
});

export default BtnOutlineGradient;
